import React from "react";
import "./Footer.scss";

export function Footer() {
  const unidad = "Unidad de Docencia de Jujuy";
  const desarrollo = "Equipo de desarrollo";
  const anio = new Date().getFullYear();
  return (
    <div className="footer">
      <div className="footer__noResponsive">
        © 2023-{anio} | {unidad} | <a href="/desarrolladores">{desarrollo}</a>
      </div>

      <div className="footer__Responsive">
        © 2023-{anio} | {unidad}
        <br></br>
        <a href="/desarrolladores">{desarrollo}</a>
      </div>
    </div>
  );
}
